var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Filters extends Component {
    constructor() {
        super('Filters', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#btn-open-filters').on('click', (event) => {
                event.preventDefault();
                $('.filters-xs').addClass('is-opened');
            });
            $('#btn-close-filters').on('click', (event) => {
                event.preventDefault();
                $('.filters-xs').removeClass('is-opened');
            });
            $(document).on('facetwp-loaded', () => {
                let activeFacetCount = 0;
                for (const [key, value] of Object.entries(FWP.facets)) {
                    if (Array.isArray(value) && value.length > 0 || typeof value === 'string' && value.length > 0) {
                        activeFacetCount++;
                    }
                }
                ;
                $('#active-filters-count').text(activeFacetCount);
                if (activeFacetCount > 0) {
                    $('#active-filters-count').removeClass('opacity-0');
                    $('.facetwp-reset').removeClass('opacity-50');
                }
                else {
                    $('#active-filters-count').addClass('opacity-0');
                    $('.facetwp-reset').addClass('opacity-50');
                }
                $('.filters-xs').removeClass('is-opened');
                Filters.facets.forEach((name) => {
                    Filters.initClearButton(name);
                });
                Filters.checkScroll();
                Filters.sortLanguageFacet();
            });
            $(document).on('facetwp-refresh', () => {
                Filters.checkScroll();
                Filters.sortLanguageFacet();
            });
            $('body').on('click', '.facetwp-pager a', (event) => {
                $.scrollTo(0);
            });
            this.success();
        });
    }
    static initClearButton(facetName) {
        const dropdown = $('.filters [data-name="' + facetName + '"] .fs-dropdown');
        const resetButton = $.parseHTML('<a href="#" class="btn-reset-facet d-flex justify-content-between ps-12 pe-12 py-7 border-bottom border-2 fw-normal">Réinitialiser les filtres <i class="position-relative d-block border border-2 rounded-circle"></i></a>');
        dropdown.prepend(resetButton);
        resetButton.on('click', (event) => {
            event.preventDefault();
            FWP.reset();
            //FWP.reset(facetName);
            dropdown.addClass('fs-hidden');
        });
    }
    static checkScroll() {
        Filters.facets.forEach((facetName) => {
            const options = $('.filters [data-name="' + facetName + '"] .fs-option');
            if (options.length > 5) {
                $('.filters [data-name="' + facetName + '"]').addClass('is-scrollable');
            }
            else {
                $('.filters [data-name="' + facetName + '"]').removeClass('is-scrollable');
            }
        });
    }
    /*
    * Order facetwp-facet-language by alphabetical order
    */
    static sortLanguageFacet() {
        const languageFacets = [];
        $('.facetwp-facet-language').each((facet) => {
            facet.find('.fs-option').forEach((element) => {
                languageFacets.push(element);
            });
            languageFacets.sort((a, b) => {
                var _a, _b;
                const textA = ((_a = a.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '';
                const textB = ((_b = b.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '';
                return textA.localeCompare(textB);
            });
            // Remove facet with empty inner text
            for (let i = languageFacets.length - 1; i >= 0; i--) {
                if (!languageFacets[i].textContent || languageFacets[i].textContent.trim() === '') {
                    languageFacets.splice(i, 1);
                }
            }
            // Let "All languages" option at the top
            const allLanguagesElementIndex = languageFacets.findIndex((el) => {
                var _a, _b;
                return ((_a = el.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('all languages')) || ((_b = el.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes('toutes les langues'));
            });
            if (allLanguagesElementIndex > -1) {
                const allLanguagesElement = languageFacets.splice(allLanguagesElementIndex, 1)[0];
                languageFacets.unshift(allLanguagesElement);
            }
            facet.find('.fs-options').html(languageFacets.map((el) => el.outerHTML).join(''));
        });
    }
}
Filters.facets = ['themes', 'domain', 'publication_year'];
